import type { ApiErrorBody } from '@ads/shared';

export class ApiError extends Error {
  constructor(readonly status: number, readonly code: string, message: string, readonly details?: unknown) {
    super(message);
  }
}

/** Quem ouve isto leva o usuário ao login quando a sessão cai. */
export const sessionEvents = new EventTarget();

async function parseError(res: Response): Promise<ApiError> {
  let body: ApiErrorBody | null = null;
  try { body = await res.json() as ApiErrorBody; } catch { /* corpo vazio */ }
  const e = body?.error;
  return new ApiError(res.status, e?.code ?? 'http_' + res.status, e?.message ?? 'Não foi possível completar a ação.', e?.details);
}

/**
 * Toda chamada à API passa por aqui. Mutação sempre vai com corpo JSON
 * (mesmo vazio) — é o que a proteção CSRF do servidor espera.
 */
export async function api<T>(path: string, opts: { method?: string; body?: unknown; signal?: AbortSignal } = {}): Promise<T> {
  const method = opts.method ?? 'GET';
  const res = await fetch('/api' + path, {
    method,
    credentials: 'same-origin',
    headers: method === 'GET' ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
    ...(method !== 'GET' ? { body: JSON.stringify(opts.body ?? {}) } : {}),
    ...(opts.signal ? { signal: opts.signal } : {}),
  });
  if (res.status === 401 && path !== '/auth/login') sessionEvents.dispatchEvent(new Event('expired'));
  if (!res.ok) throw await parseError(res);
  if (res.status === 204) return undefined as T;
  return await res.json() as T;
}

export { parseError };
